import { useSelector } from 'react-redux';
import { Typography } from '@vivaahealth/design-system';

import * as store from '../../../reducers/store';
import { PrevisitFormTemplateFieldConfig } from '../../../api';
import { ConfigurationHeader } from '../../../utils/review';

const PersonalInformationHeader: ConfigurationHeader = ({ fields }) => {
  const patient = useSelector((state: store.All) => state.loggedInPatient);
  const patientFirstNameField = fields?.find(
    (field) =>
      field.primitive ===
      PrevisitFormTemplateFieldConfig.Primitive.PatientFirstName,
  );
  const patientLastNameField = fields?.find(
    (field) =>
      field.primitive ===
      PrevisitFormTemplateFieldConfig.Primitive.PatientLastName,
  );

  if (!patient && !patientFirstNameField && !patientLastNameField) {
    return null;
  }

  const patientFirstName =
    patientFirstNameField?.value ??
    patient?.preferredFirstName ??
    patient?.firstName;
  const patientLastName = patientLastNameField?.value ?? patient?.lastName;

  const nameList = [patientFirstName, patientLastName];
  const name = nameList.filter((n) => !!n).join(' ');

  if (!name.length) {
    return null;
  }

  return (
    <Typography bold variant="headline-small">
      {name}
    </Typography>
  );
};

export default PersonalInformationHeader;
